import React from 'react';
import cs from 'classnames';
import { IconSvg } from './Icon.generated';
export function Icon(props) {
  if (!props.icon) {
    return null;
  }

  return /*#__PURE__*/React.createElement("svg", {
    className: cs('Icon', "Icon--".concat(props.icon), props.spin ? 'Icon--spin' : undefined, props.className),
    style: props.style,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-hidden": props.title ? undefined : true
  }, props.title && /*#__PURE__*/React.createElement("title", null, props.title), IconSvg[props.icon]);
}